import React, { useState } from 'react';
import SectionH2 from '../heading/SectionH2';
import { CITY_PAGES } from '../../data/cities';
import BuzzerChecker from './BuzzerChecker';

const CityIntro = ({ channel }) => {
  const city = CITY_PAGES[channel];
  const [showChecker, setShowChecker] = useState(false);
  if (!city) return null;

  // The intro is one paragraph of two sentences. On small screens we show them
  // as two separate paragraphs; on larger screens they stay as one block.
  const introText = city.intro.paragraphs[0];
  const splitAt = introText.indexOf('. ');
  const firstSentence = splitAt >= 0 ? introText.slice(0, splitAt + 1) : introText;
  const secondSentence = splitAt >= 0 ? introText.slice(splitAt + 2) : '';

  if (showChecker) {
    return (
      <div className="mx-auto max-w-3xl px-8 text-white">
        <BuzzerChecker />
        <div className="pt-6 text-center">
          <button
            type="button"
            onClick={() => setShowChecker(false)}
            className="text-sm text-gray-lowkey-medium underline"
          >
            Back to overview
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-8 text-white">
      <div className="flex flex-col items-center pb-5">
        <SectionH2 title={city.intro.heading} />
      </div>
      <div className="text-center font-space-grotesk-regular text-white">
        {/* sm and up: single paragraph */}
        <p className="hidden sm:block">{introText}</p>
        {/* small screens: two paragraphs */}
        <div className="space-y-4 sm:hidden">
          <p>{firstSentence}</p>
          {secondSentence && <p>{secondSentence}</p>}
        </div>
      </div>
      <div className="flex flex-col items-center pt-8">
        <button
          type="button"
          onClick={() => setShowChecker(true)}
          className="rounded border border-green-lowkey bg-green-lowkey py-2 px-4 text-base font-medium text-black hover:bg-black hover:text-green-lowkey focus:ring-4 focus:ring-gray-800"
        >
          Check if your buzzer works with Lowkey
        </button>
      </div>
    </div>
  );
};

export default CityIntro;
